import {Component} from '@angular/core';
import {Empresa, LoginFuncionario, Ponto} from '../../../models/interfaces';
import {LoginService} from '../../../servicos/login.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-ez-painel',
  templateUrl: './ez-painel.component.html',
  styleUrls: ['./ez-painel.component.scss']
})
export class EzPainelComponent {
  user?: LoginFuncionario;
  Cliente: string = 'Sem nome de Empresa definido';
  opened: boolean = false;

  latitude: number = 0;
  longitude: number = 0;
  loading: boolean = false;
  erroMensagem: string = '';
  dadosEmpresa!: Empresa;
  ips?: string;

  constructor(
    private login: LoginService,
    private router: Router,
  ) {
    const a = localStorage.getItem('Ponto') ?? null;
    if (a === null) {
      router.navigate(['login']);
      return;
    }

    this.user = JSON.parse(a);
    this.AtualizarDados();
    this.EmpresaDados();

    this.Cliente =
      this.user?.funcionario?.empresa.nome ?? 'Sem nome de Empresa definido';
    this.checkarPermERedirecionar();
  }

  logoff() {
    this.login.Logout();
    this.router.navigate(['login']);
  }

  AtualizarDados() {
    const p = this.user?.idd;
    if (p !== undefined) {
      this.login.loginPontoAtualizaCadastro(p).subscribe({
        next: (r: LoginFuncionario) => {
          localStorage.removeItem('Ponto');
          localStorage.removeItem('SGIWEBtoken');
          localStorage.setItem('Ponto', JSON.stringify(r));
          this.user = r;
        },
        error: () => {
          return;
        },
      });
    }
  }

  EmpresaDados() {
    this.login.buscaDadosEmpresaPw().subscribe({
      next: (r: Empresa) => {
        this.dadosEmpresa = r;
      },
      error: () => {
        return;
      },
    });
  }

  navegar(s: string) {
    this.router.navigateByUrl(s);
  }

  private checkarPermERedirecionar() {
    if (this.user?.funcionario?.registrarPonto) {
      this.navegar('ez/(ez:ponto)');
    } else if (this.user?.funcionario?.consultaPonto) {
      this.navegar('ez/(ez:consulta-ponto)');
    } else if (this.user?.funcionario?.solAjusPonto) {
      this.navegar('ez/(ez:ajuste-ponto)');
    } else if (this.user?.funcionario?.justFalta) {
      this.navegar('ez/(ez:just-falta)');
    } else if (this.user?.funcionario?.assEspPonto) {
      this.navegar('ez/(ez:espelho-ponto)');
    } else if (this.user?.funcionario?.saldoBH) {
      this.navegar('ez/(ez:saldo-bh)');
    } else {
      this.navegar('login');
    }
  }
}
